/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { isClient } from 'frontend/helpers/ssr-helper';
import '../base.css';
import './facebook.css';

const ShareButton = (props) => {
  const { img, url, date, title, host, price } = props;
  const preparingLink = new URL(`${host}/share-facebook.php?`
    + `title=${title
    }&description=Salida: ${date} $ ${price
    }&img=${img
    }&url=${url}`);
  const LinkAlready = encodeURIComponent(preparingLink);
  const link = preparingLink !== '' ? LinkAlready : encodeURIComponent(document.URL);
  const handleClick = () => {
    isClient && window.open(`https://www.facebook.com/sharer.php?u=${link}`, '', 'menubar=no,toolbar=no,resizable=no,scrollbars=no,height=200,width=600');
  };
  return (
    <span className='item-btn'>
      <span className='bg-mbr-color-primario text-white color-dinamico-fondo new-share-button margenes-entre-iconos-redes' onClick={handleClick}>
        <i className='fab fa-facebook-f' />
      </span>
    </span>
  );
};

export default ShareButton;
